<div class="content1">
  <div class="step-row">
    <div class="step"></div>
    <div class="step on"></div>
  </div>

  
  <div>
    <h1 class="page-title">Verify your email address</h1>
    <p class="page-sub">Please enter the verification code sent to your email address.</p>
  </div>

  <form class="glass">
    <div class="card-body">
      <app-code-input 
          title="" 
          [loading]="false" 
          [backTitle]="'Resend Code'"
          [nextTitle]="'Submit'"
          (onReset)="requestEmailCode()"
          (onNext)="confirmEmailCode($event)">
          <span>We sent a code via email to <span style="color: dodgerblue">{{ getUserEmail() }}</span>, please enter the code above to verify your email.</span>
      </app-code-input>
    </div>
  </form>
</div>




